import { nanoid } from "nanoid";
import { useReduxDispatch } from "../../../redux/hooks";
import { updateIframeSrc } from "../../../slices/RevelationSlice";
import { useNavigate } from "react-router-dom";

export interface IAdminAreaProps {
  access: boolean;
}

export const AdminArea = ({ props }: { props: IAdminAreaProps }) => {
  const navigate = useNavigate();
  const { access } = props;
  const AdminAreaPath =
    "/adminUX/DynamicUI/Default.aspx?PageName=HelpdeskSetup";
  const dispatch = useReduxDispatch();

  const handleOnClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate("/admin");
    // dispatch(
    //   updateIframeSrc(
    //     `${AdminAreaPath}${AdminAreaPath.indexOf("?") > -1 ? "&" : "?"
    //     }d=${nanoid()}`
    //   )
    // );
  };

  if (access) {
    return (
      <a
        onClick={handleOnClick}
        className="grid place-content-center"
        title="Admin settings"
        href={'./deeplink?url=' + AdminAreaPath}
      >
        <img
          src="./images/img_gear.jpg"
          alt="admin settings"
          title="Admin settings"
        />
      </a>
    );
  }
  return null;
  // left here for testing
  // return (
  //   <button
  //     onClick={handleOnClick}
  //     className="grid place-content-center h-[30px] w-[30px]"
  //     title="Admin Area"
  //   >
  //     <img src="./images/img_gear.jpg" alt="admin area" title="Admin Area" />
  //   </button>
  // );
};
